import ReactTooltip from 'react-tooltip'

import { CheckIcon } from '../../../../components/ReusableComponents/Icons/Check'
import { CrossIcon } from '../../../../components/ReusableComponents/Icons/Cross'
import { Cell } from '../../../../components/ReusableComponents/Table/index'
import styles from './CheckCell.module.scss'

const GreenCheck = () => <CheckIcon className={styles.greenCheck} />
const GrayCross = () => <CrossIcon className={styles.grayCross} />

const CheckCell = ({ campaign, ...props }) => {
  return (
    <Cell className={styles.checkCell} {...props}>
      {campaign ? (
        <div
          {...(campaign.isActive
            ? {}
            : {
                'data-tip': `${campaign.disabledReason || 'No reason'}`,
                'data-for': `health-check-auto-invite-tooltip`
              })}
        >
          {campaign.isActive ? <GreenCheck /> : <GrayCross />}
          {campaign.isActive ? null : (
            <ReactTooltip
              id={`health-check-auto-invite-tooltip`}
              place="top"
              type="dark"
              effect="solid"
            />
          )}
        </div>
      ) : (
        <div className={styles.checkCell}>
          <GrayCross />
        </div>
      )}
    </Cell>
  )
}

export default CheckCell
